import { render, staticRenderFns } from "./number-animation.vue?vue&type=template&id=4b9bc23e&scoped=true"
import script from "./number-animation.vue?vue&type=script&lang=js"
export * from "./number-animation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9bc23e",
  null
  
)

export default component.exports